__turbopack_context__.v({
  "wrp": "termsOfUse-module-scss-module__-bvPTW__wrp",
});
